var _a, _b;
import { grey400, blue400, orange400, green400, blueGrey400, grey100, indigo400 } from 'material-ui/styles/colors';
export var TaskStatuses;
(function (TaskStatuses) {
    TaskStatuses[TaskStatuses["Backlog"] = 2] = "Backlog";
    TaskStatuses[TaskStatuses["Todo"] = 3] = "Todo";
    TaskStatuses[TaskStatuses["Doing"] = 4] = "Doing";
    TaskStatuses[TaskStatuses["Testable"] = 5] = "Testable";
    TaskStatuses[TaskStatuses["Done"] = 6] = "Done";
    TaskStatuses[TaskStatuses["None"] = 7] = "None";
})(TaskStatuses || (TaskStatuses = {}));
var enumNamings = (_a = {},
    _a[TaskStatuses.Backlog] = 'Backlog',
    _a[TaskStatuses.Todo] = 'Todo',
    _a[TaskStatuses.Doing] = 'Folyamatban',
    _a[TaskStatuses.Testable] = 'Tesztelhető',
    _a[TaskStatuses.Done] = 'Lezárt',
    _a[TaskStatuses.None] = '-',
    _a);
var colorPalette = (_b = {},
    _b[TaskStatuses.Backlog] = grey400,
    _b[TaskStatuses.Todo] = indigo400,
    _b[TaskStatuses.Doing] = blue400,
    _b[TaskStatuses.Testable] = orange400,
    _b[TaskStatuses.Done] = green400,
    _b[TaskStatuses.None] = grey100,
    _b);
var TaskStatus = /** @class */ (function () {
    function TaskStatus(dto) {
        this.id = dto.id;
        this.name = dto.name;
        this.selectable = dto.selectable;
    }
    TaskStatus.stringify = function (value) {
        return enumNamings[value] || '';
    };
    TaskStatus.colorify = function (value) {
        return colorPalette[value] || 'black';
    };
    TaskStatus.getPalette = function () {
        return [
            grey400,
            indigo400,
            blue400,
            orange400,
            green400,
            grey100
        ];
    };
    Object.defineProperty(TaskStatus.prototype, "color", {
        get: function () {
            return colorPalette[this.id] || blueGrey400;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskStatus.prototype, "enum", {
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    return TaskStatus;
}());
export { TaskStatus };



//////////////////
// WEBPACK FOOTER
// ./src/models/TaskStatus.ts
// module id = 30
// module chunks = 0